
import { useState } from 'react';

export default function WhatsAppButton() {
  const [showTooltip, setShowTooltip] = useState(false);

  const phoneNumber = '1234567890'; // Replace with your WhatsApp number
  const message = encodeURIComponent('Hi! I\'m interested in Fluffy Pets services. 🐾');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <div className="fixed bottom-6 left-6 z-50 flex items-end gap-3">
      {showTooltip && (
        <div className="bg-white rounded-xl shadow-lg px-4 py-3 text-sm text-gray-700 font-medium animate-fade-in whitespace-nowrap mb-1">
          Chat with us on WhatsApp!
          <div className="absolute -right-2 bottom-4 w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[8px] border-l-white"></div>
        </div>
      )}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className="w-14 h-14 bg-[#25D366] hover:bg-[#20bd5a] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all hover:scale-110 cursor-pointer animate-bounce-slow"
        aria-label="Chat on WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-2xl"></i>
      </a>
    </div>
  );
}
